import SectionMessage from '@atlaskit/section-message';
import PremiumIcon from '@atlaskit/icon/core/premium';
import IconDefault from "../../../../../../packages/design-system/icon/examples/constellation/icon-default.tsx";
import IconSmallExample from "../../../../../../packages/design-system/icon/examples/constellation/icon-small.tsx";
import IconColor from "../../../../../../packages/design-system/icon/examples/constellation/icon-color.tsx";
import IconLabel from "../../../../../../packages/design-system/icon/examples/constellation/icon-label.tsx";
import IconSpacing from "../../../../../../packages/design-system/icon/examples/constellation/icon-spacing.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_default_tsx from "!!raw-loader!../../../../../../packages/design-system/icon/examples/constellation/icon-default.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_small_tsx from "!!raw-loader!../../../../../../packages/design-system/icon/examples/constellation/icon-small.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_color_tsx from "!!raw-loader!../../../../../../packages/design-system/icon/examples/constellation/icon-color.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_label_tsx from "!!raw-loader!../../../../../../packages/design-system/icon/examples/constellation/icon-label.tsx";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_spacing_tsx from "!!raw-loader!../../../../../../packages/design-system/icon/examples/constellation/icon-spacing.tsx";
import * as React from 'react';
export default {
  SectionMessage,
  PremiumIcon,
  IconDefault,
  IconSmallExample,
  IconColor,
  IconLabel,
  IconSpacing,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_default_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_small_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_color_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_label_tsx,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHicon_spacing_tsx,
  React
};